import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@rtls-environment/environment';
import { Country } from '@rtls/core/models/location/country.model';
import { Observable } from 'rxjs';

@Injectable()
export class CountryService {
	constructor(private http: HttpClient) {}

	// TODO: Check typings, not consistent with received object (Old ones: Country)
	public getCountryFromLatLng(lat: number, lon: number): Observable<any> {
		const url = `https://eu1.locationiq.com/v1/reverse.php?key=pk.d7cdd5848a62ff54d8e0741282b9ccbe&lat=${lat}&lon=${lon}&format=json`;
		return this.http.get(url);
	}

	public getCountries(lang?: string): Observable<Country[]> {
		return this.http.get<Country[]>(`${environment.thingsApi}/countries/?lang=${lang}`);
	}
}
